__turbopack_context__.v({
  "canvas": "MwgMLa_canvas",
  "canvasBlock": "MwgMLa_canvasBlock",
  "canvasHeading": "MwgMLa_canvasHeading",
  "canvasLayout": "MwgMLa_canvasLayout",
  "canvasSubtitleLine": "MwgMLa_canvasSubtitleLine",
  "canvasTitleLine": "MwgMLa_canvasTitleLine",
  "content": "MwgMLa_content",
  "copy": "MwgMLa_copy",
  "illustration": "MwgMLa_illustration",
  "line": "MwgMLa_line",
  "lines": "MwgMLa_lines",
  "marker": "MwgMLa_marker",
  "markerBlue": "MwgMLa_markerBlue",
  "markerGreen": "MwgMLa_markerGreen",
  "markerOrange": "MwgMLa_markerOrange",
  "primaryBlock": "MwgMLa_primaryBlock",
  "secondaryBlocks": "MwgMLa_secondaryBlocks",
  "section": "MwgMLa_section",
  "thought": "MwgMLa_thought",
  "thoughtCard": "MwgMLa_thoughtCard",
});
